// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import third-party libraries
import moment from 'moment';

function AdminStudyListItem({ sponsor, study }) {
  return (
    <tr>
      <td className="_40"><Link to={`/admin/content-management/studies/${study._id}`}>{study.name}</Link></td>
      <td className="_20">{sponsor.name}</td>
      <td className="_20">
        <Link to={`/admin/content-management/studies/${study._id}/sites`} style={{marginRight: '16px'}}>Sites</Link>
        <Link to={`/admin/content-management/studies/${study._id}/roles`}>Roles</Link>

      </td>
      <td className="_20">{moment(study.updated).format("MMMM Do YYYY, h:mm a")}</td>
    </tr>
  )
}

AdminStudyListItem.propTypes = {
  sponsor: PropTypes.object.isRequired
  , study: PropTypes.object.isRequired
}

export default AdminStudyListItem;



// WEBPACK FOOTER //
// modules/study/components/AdminStudyListItem.js.jsx